const getPageIndexFromStorage = (key) => {
    const pageIndexKey = `page_index_${key}`;
    const pageIndexExpirationKey = `page_index_expiration_${key}`;
    const storedIndex = sessionStorage.getItem(pageIndexKey);
    const storedExpiration = sessionStorage.getItem(pageIndexExpirationKey);

    if (storedIndex && storedExpiration) {
        const currentTime = new Date().getTime();
        const expirationTime = new Date(storedExpiration).getTime();

        if (currentTime < expirationTime) {
            return Number(storedIndex);
        }
        else {
            sessionStorage.removeItem(pageIndexKey);
            sessionStorage.removeItem(pageIndexExpirationKey);
        }
    }

    return 1;
};

const setPageIndexInStorage = (key, index = 1, cacheTime) => {
    const pageIndexKey = `page_index_${key}`;
    const pageIndexExpirationKey = `page_index_expiration_${key}`;
    const expirationDate = new Date();
    expirationDate.setMinutes(expirationDate.getMinutes() + cacheTime);

    sessionStorage.setItem(pageIndexKey, index.toString());
    sessionStorage.setItem(pageIndexExpirationKey, expirationDate.toISOString());
};

const indexSessionStorage = {
    get : getPageIndexFromStorage,
    set : setPageIndexInStorage
}

export default indexSessionStorage;